import React, { useCallback } from "react"
import { InputMascara } from "./InputMascara"
import globalMU from "../../../globalMU"

export type InputCepProps = {
  cep: string
  onCepModificado: (cep: string) => void
  emitirComMascara?: boolean
  disabled?: boolean
  className?: string
  id?: string
}

export const InputCep = (props: InputCepProps) => {
  const handleValorModificado = useCallback((valor: string) => {
    const cepSomenteNumeros = valor.replace(/\D/g, "") // Remove caracteres não numéricos
    if (cepSomenteNumeros.length > 0 && !valor) {
      globalMU.showErrorMessage("Tamanho do cep inválido")
    }
    props.onCepModificado(valor)
  }, [props.onCepModificado])

  return (
    <InputMascara
      disabled={props.disabled}
      className={props.className}
      mascara="99.999-999"
      //inputMode="numeric"
      type="tel"
      emitirComMascara={
        props.emitirComMascara === undefined || props.emitirComMascara === true
      }
      onValorModificado={handleValorModificado}
      valor={props.cep}
      id={props.id || "InputCep_Default"}
      key={props.id || "InputCep_Default"}
    />
  )
}